<template>
  <div>
    <loading 
      :active.sync="isLoading" 
      color="#64B9B0"
    ></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Empresas</li>
        </ol>

        <div class="row">
          <div class="col-md-12 ">
            <div class="pull-right">
              <router-link to="empresas/criar-empresa"  class="btn_1 medium mb-3">Criar nova Empresa</router-link>
            </div>
          </div>
        </div>

        <v-card>
          <v-card-title>
            <h3>Empresas</h3>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table rows-per-page-text="Linhas por Página" :no-data-text="textoTabela" :headers="headers" :items="empresas" :search="search" :pagination.sync="pagination" class="less-space">
            <template slot="items" slot-scope="props">
              <td>{{ padronizaData(props.item.created_at)}}</td>
              <td>{{ props.item.nome_empresa }}</td>
              <td>{{ props.item.CNPJ | VMask('###.###.###-##') }}</td>
              <td>{{ props.item.CEP }}</td>
              <td class="text-xs-right many-buttons">
                <span class="text-xs-right many-buttons" v-if="!(props.item.deleted_at)">
                  <router-link
                    class="btn mr-2 text-white blue-grey darken-4"
                    :to="'empresas/'+props.item.id"
                  >
                    <i class="fa fa-eye"></i> Detalhes
                  </router-link>
                  <button class="btn btn-danger text-center" @click="desativaEmpresa(props.item)">
                    <i class="fa fa-times"></i> Desativar
                  </button>
                </span>
                <span class="text-xs-right many-buttons" v-else>
                  <button class="btn btn-info text-center text-white" @click="ativaEmpresa(props.item)">
                    <i class="fa fa-check"></i> Ativar
                  </button>
                </span>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
          </v-data-table>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import funcoesGerais from "@/assets/js/funcoes.js";
import { ajax, tratamento_requisicao, alerta, confirmaSoft } from "@/utils/util";

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      search: "",
      pagination: {
        rowsPerPage: 5
      },
      headers: [
        { text: "Data de criação", value: "created_at" },
        { text: "Nome da Empresa", value: "nome_empresa" },
        { text: "CNPJ", value: "CNPJ"},
        { text: "CEP", value: "CEP"},
        { text: "", value: ""}
      ],
      empresas: [],
      isLoading: false
    };
  },
  mounted() {
    var self = this;

    self.isLoading = true;
    ajax("get", "empresas")
      .then(res => {
        self.isLoading = false;
        self.empresas = res;
      })
      .catch(error => {
        self.isLoading = false;
        tratamento_requisicao(error);
      });
  },
  methods: {
    async desativaEmpresa(empresa){
      if(await confirmaSoft()) {
        let self = this;
        self.isLoading = true;
        ajax("delete", "empresas/" + empresa.id)
          .then(() => {
            let indexItemRemovido = self.empresas.findIndex(
              x => x.id == empresa.id
            );
            self.empresas[indexItemRemovido].deleted_at = 1;
            self.isLoading = false;
            alerta(
              "success",
              "Desativado",
              "Empresa desativada com sucesso!"
            );
          })
          .catch(error => {
            self.isLoading = false;
            tratamento_requisicao(error);
          });
      }
    },
    ativaEmpresa(empresa){
      let self = this;
      self.isLoading = true;
      ajax("post", "empresas/" + empresa.id, {deleted_at: null})
      .then(() => {
        self.isLoading = false;
        let indexItemRemovido = self.empresas.findIndex(
            x => x.id == empresa.id
        );
        self.empresas[indexItemRemovido].deleted_at = null;
        alerta(
          "success",
          "Ativada",
          "Empresa ativada com sucesso!"
        );
      })
      .catch(err => {
        self.isLoading = false;
        tratamento_requisicao(err);
      })
    }
  }
};
</script>